export default class SelectItem {
  public key: string;
  public values: string[];
  public obj: any;

  constructor(key: string, values?: string[], obj?: any) {
    this.key = key;
    this.values = values || [key];
    this.obj = obj;
  }
}
